import React, { useState, useEffect, useRef } from 'react';

import { getInputValue, formatNumericValue, parseInputValue, renderSyncIcon } from '../utils';

import DisplayCost from './DisplayCost';

const TrimsSection = ({
	data = [],
	totalCost = 0,
	onChange,
	trimsAdditionalCharge = '',
	onTrimsAdditionalChargeChange,
	isEditable = true,
	onRecost
}) => {
	const [originalTrimsData, setOriginalTrimsData] = useState([]);
	const [additionalCharge, setAdditionalCharge] = useState(trimsAdditionalCharge);
	const [hasChanged, setHasChanged] = useState(false);
	const isInitialMount = useRef(true);
	const prevDataRef = useRef(null);
	const prevAdditionalChargeRef = useRef(null);

	useEffect(() => {
		const dataString = JSON.stringify(data);
		const prevDataString = JSON.stringify(prevDataRef.current);

		if (dataString === prevDataString) {
			return;
		}
		setOriginalTrimsData(data && data.length > 0 ? [...data] : []);
		prevDataRef.current = data;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [data]);

	useEffect(() => {
		if (prevAdditionalChargeRef.current !== trimsAdditionalCharge) {
			setAdditionalCharge(
				trimsAdditionalCharge !== undefined && trimsAdditionalCharge !== null
					? trimsAdditionalCharge
					: ''
			);
			prevAdditionalChargeRef.current = trimsAdditionalCharge;
		}
	}, [trimsAdditionalCharge]);

	const notifyChange = (updatedTrims) => {
		if (onChange && !isInitialMount.current) {
			onChange(updatedTrims);
		}
	};

	const handleTrimsChange = (idx, value) => {
		const updatedValue = parseInputValue(value);
		let cloneTrims = [...originalTrimsData];
		if (idx < cloneTrims.length) {
			cloneTrims[idx] = {
				...cloneTrims[idx],
				trims_price_usd: updatedValue,
				total_price: updatedValue
			};
			setOriginalTrimsData(cloneTrims);
			setHasChanged(true);
			notifyChange(cloneTrims);
		}
	};

	const handleAdditionalChargeChange = (value) => {
		const updatedValue = parseInputValue(value);
		setAdditionalCharge(updatedValue);
		setHasChanged(true);
		if (onTrimsAdditionalChargeChange && !isInitialMount.current) {
			onTrimsAdditionalChargeChange(formatNumericValue(updatedValue));
		}
	};

	const onRecostChange = () => {
		onRecost('TRIMS_CHANGE');
		setHasChanged(false);
	};

	return (
		<div className="single-table trims-content mt-5">
			<div className="d-flex justify-content-between mb-2">
				<p>
					Trims Cost Metrics
					{hasChanged && (
						<span
							title="Unsaved changes"
							className="sync-icon ml-1 cursor-pointer"
							style={{ display: 'inline-flex', alignItems: 'center' }}
							onClick={onRecostChange}
						>
							{renderSyncIcon()}
						</span>
					)}
				</p>
			</div>
			<div className="row">
				{originalTrimsData?.map((item, idx) => {
					return (
						<div className="col-md-6 col-sm-12 mb-2">
							<p className="regular-12 gray_dark_02 pb-1">{item?.trim_name}</p>
							<input
								type="number"
								step="0.01"
								value={getInputValue(item.trims_price_usd)}
								onChange={(e) => handleTrimsChange(idx, e.target.value)}
								readOnly={!isEditable}
							/>
						</div>
					);
				})}
				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Trims Additional Charge (%)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(additionalCharge)}
						onChange={(e) => handleAdditionalChargeChange(e.target.value)}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Trims Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">
						<DisplayCost totalCost={totalCost} />
					</p>
				</div>
			</div>
		</div>
	);
};

export default TrimsSection;
